import { MathJax, MathJaxContext } from "better-react-mathjax";

const RenderMathQuestion = ({ question }) => {
  const config = { loader: { load: ["[tex]/html"] } };

  const cleanedHtml = question
    .replace(/<head.*?>.*?<\/head>/gis, "")
    .replace(/<html.*?>/gis, "")
    .replace(/<\/html>/gis, "")
    .replace(/<body.*?>/gis, "")
    .replace(/<\/body>/gis, "")
    .replace(/<p.*?>/gis, "")
    .replace(/<\/p>/gis, "")
    .trim();

  return (
    <MathJaxContext config={config}>
      <MathJax dynamic>
        <div dangerouslySetInnerHTML={{ __html: cleanedHtml }} />
      </MathJax>
    </MathJaxContext>
  );
};
export default RenderMathQuestion;
